{
  "orderStepper": {
    "selectProduct": "Select product",
    "checkoutDetails": "Order information",
    "deliveryOptions": "Delivery options",
    "orderCompleted": "Order completed"
  },
  "selectProduct": {
    "title": "Select product",
    "productListing": {
      "sortingPriceAsc": "Lowest first",
      "sortingPriceDesc": "Highest first",
      "productsSortLabel": "Sort by price",
      "textSearchTitle": "Search by product name",
      "textSearchPlaceholder": "e.g. iPhone 12",
      "brandFilterTitle": "Filter by brand",
      "productPriceLabel": "Price",
      "noProductsFoundTitle": "No products found",
      "getProductsErrorTitle": "Product list loading failed",
      "month": "month",
      "monthPeriod": "months",
      "singlePayment": "single payment",
      "vat": "VAT",
      "priceIncludingVat": "Price incl.",
      "priceExcludingVat": "Price excl.",
      "filterResultsButton": "Filter results",
      "showButton": "Show"
    },
    "userDetail": {
      "contactTitle": "Contact",
      "deviceLimitTitle": "Device limit",
      "allowanceTitle": "Max price/device",
      "singleDevicePolicy": {
        "enabled": "1/1 remaining",
        "inEffect": "0/1 remaining",
        "disabled": "Unlimited",
        "undefined": "Not defined"
      },
      "allowance": {
        "monthly": "{{amount}} {{currency}}/month (incl. VAT)",
        "oneTime": "{{amount}} {{currency}} (incl. VAT)",
        "missing": "Value missing",
        "unlimited": "Unlimited",
        "undefined": "Not defined"
      }
    }
  },
  "bundle": {
    "title": "Select product",
    "readyButton": "Go to checkout",
    "secondaryButton": "Continue shopping",
    "comesBundledUp": "Comes bundled up with",
    "availabilityAvailable": "Available",
    "availabilityFewLeft": "Few left",
    "availabilityNotAvailable": "Not available",
    "availabilityReadyToShip": "All items in the bundle are ready to ship",
    "availabilityNotReadyToShip": "Out of stock at the moment",
    "paymentSingle": "Single payment",
    "paymentMulti": "month agreement",
    "totalPrice": "Total price",
    "months": "months",
    "showFullDescription": "show more",
    "totalMonthlyPrice": "Total monthly price",
    "vat": "VAT",
    "includingVat": "incl.",
    "excludingVat": "excl.",
    "perMonth": "Per month",
    "canNotShowBundle": "Can not show bundle",
    "description": "Description",
    "dynamicPricingInsurance": {
      "insured": "Insurance included",
      "shortExplanation": "The device is insured against:",
      "bulletPointFirstAccidents": "Unforeseen events",
      "bulletPointSecondTheft": "Loss and theft",
      "bulletPointThirdWater": "Water damage",
      "terms": "Insurance conditions"
    },
    "singleDevicePolicyTitle": "Single device policy limit full.",
    "singleDevicePolicyText": "You have a limit of one device and can not order a new one.",
    "yourAllowance": "User’s max price/device",
    "yourAllowanceExplanation": "User's employer covers up to this amount",
    "salaryDeductionEstimate": "Salary deduction",
    "getBundleErrorTitle": "Error while loading bundle",
    "addonProductImageAltText": "Product image",
    "monthlySalaryDeductionExplanation": "The device costs exceeding user´s max price/device will be deducted monthly from their salary. This is the estimated sum to be deducted from their salary once a month during the agreement period.",
    "oneTimeSalaryDeductionExplanation": "The device costs exceeding user´s max price/device will be deducted from their salary as a one-time payment. This is the estimated sum deducted from their salary in the first month of the agreement period.",
    "confirmModal": {
      "title": "Confirm order terms with recipient",
      "info": "Please confirm that the recipient of this order is aware of and agrees with the following details:",
      "oneTimePrice": "The price of the device is {{priceToShow}}",
      "monthlyPrice": "The price of the device is {{priceToShow}}/month",
      "leasePeriod": "The agreement period is {{periodInMonths}} months",
      "monthlySalaryDeductionExplanation": "The price exceeds the user´s monthly max price/device by {{amountExceeded}}/month, which will be deducted from their salary each month",
      "oneTimeSalaryDeductionExplanation": "The price exceeds the user´s max price/device by {{amountExceeded}}, which will be deducted from their salary as a one-time payment in the first month of the agreement period",
      "singleDevicePolicyToBeFull": "After ordering this device the user has used their purchase right for 1 out of 1 devices",
      "outOfStock": "The device is out of stock and will be delivered to the customer when it becomes available. There is no estimate of the shipping time at the moment, but recurrent status updates will be sent to the customer´s email.",
      "confirmButton": "Confirm",
      "cancelButton": "Cancel"
    }
  },
  "productCart": {
    "yourCart": "Your cart",
    "emptyCart": "Empty cart.",
    "emptyCartHelp": "In this early version of our shop, you can have just one product bundle in your shopping cart at a time.",
    "availabilityAvailable": "Available",
    "availabilityNotAvailable": "Not available",
    "availabilityReadyToShip": "Ready to ship",
    "availabilityFewLeft": "Few left",
    "availabilityNotReadyToShip": "Not ready to ship",
    "totalMonthlyPrice": "Total monthly price",
    "vat": "VAT",
    "includingVat": "incl.",
    "excludingVat": "excl.",
    "paymentSingle": "Single payment",
    "paymentMulti": "month agreement",
    "totalPrice": "Total price",
    "months": "months",
    "perMonth": "Per month",
    "yourAllowance": "User’s max price/device",
    "yourAllowanceExplanation": "User's employer covers up to this amount",
    "salaryDeductionEstimate": "Salary deduction",
    "cartEmpty": "Cart is empty",
    "monthlySalaryDeductionExplanation": "The device costs exceeding user´s max price/device will be deducted monthly from their salary. This is the estimated sum to be deducted from their salary once a month during the agreement period.",
    "oneTimeSalaryDeductionExplanation": "The device costs exceeding user´s max price/device will be deducted from their salary as a one-time payment. This is the estimated sum deducted from their salary in the first month of the agreement period."
  },
  "checkoutDetails": {
    "companyName": "Company name",
    "headline": "Order information",
    "employeeTitle": "User",
    "billingTitle": "Billing",
    "deliveryTitle": "Delivery",
    "billingTextOne": "Your order will be billed to",
    "billingTextTwo": "You cannot change this",
    "deliveryText": "We prefilled some delivery details based on saved data.",
    "deliveryQuestion": "Is this a company or a home address?",
    "form": {
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email address",
      "phoneNbr": "Phone number",
      "address1": "Additional address information",
      "address2": "Additional address information (continued)",
      "streetAddress": "Street address",
      "postalCode": "Postal code",
      "city": "City",
      "country": "Country",
      "countryPlaceholder": "Choose country",
      "companyDeliveryOption": "Company address",
      "companyDeliveryOptionDetails": "Please ensure to use delivery address. Order cannot be delivered with PB address.",
      "homeDeliveryOption": "Home address",
      "homeDeliveryOptionDetails": "Please check if address is correct.",
      "location": "Location",
      "locationReference": "Location reference",
      "locationReferenceHint": "Use this field to connect the device to a specific location.",
      "invoicingAccount": {
        "title": "Invoicing account",
        "dropdownLabel": "Current invoicing account",
        "clearSelection": "Clear selection",
        "helperText": "Selected invoicing account will be saved and the unit will be invoiced on the new invoicing account.",
        "noOptionsFoundInfo": "No invoicing account options found"
      },
      "rules": {
        "required": "required",
        "invalidEmail": "Please enter valid email.",
        "invalidPhoneNumber": "Please enter valid phone number.",
        "invalidPostalCode": "Please enter valid postal code."
      }
    },
    "nextButton": "Next",
    "cancelButton": "Go back"
  },
  "deliveryOptions": {
    "headline": "Delivery options",
    "title": "Delivery",
    "deliveryText": "Choose between our delivery options to your delivery address, located in",
    "optionDelivered": "Delivered",
    "optionDescription": "Service description",
    "deliveryEstimateNotAvailable": "Delivery time estimate not available",
    "deliveryComment": "Delivery time estimates are dependent on the order going through organization's approval and finance processes before",
    "deliveryCommentForOrganization": "Delivery time estimates are dependent on the order going through organization's finance process before",
    "confirmOrderCheckboxLabel": "I confirm that I have entered the correct delivery information, selected the intended device model and agree to the order terms.",
    "orderButton": "Place order",
    "cancelButton": "Go back",
    "errorDetailsIsMissing": "Delivery details is missing",
    "getDeliveryOptionsError": "Fetching delivery options failed",
    "placeOrderError": "Placing order failed",
    "placeOrderErrorDataInvalid": "Can not make order, some data is missing. Try to refresh and start process from the beginning.",
    "enrollmentError": "Placing order failed. Bundle contains enrolment but organization is missing enrolment ID. Please fill enrolment ID in <a>company information</a>.",
    "deliveryInvalid": "Selected delivery type can not be used for selected {{delivery}} delivery option.",
    "outOfStockDeliveryComment": "Ouf of stock delivery"
  },
  "orderCompleted": {
    "headline": "Order completed",
    "headlineApproval": "Thank you",
    "approverIconTitle": "Approver",
    "employeeIconTitle": "User",
    "deliveryIconTitle": "Delivery",
    "ordererIconTitle": "Orderer",
    "orderTitleForInactiveUser": "Order for {{email}} has been placed",
    "orderTitleForOrganization": "Order has been placed",
    "orderTitle": "Order for {{given_name}} {{family_name}} has been placed",
    "detailsTitle": "Order details",
    "yourOrderText": "Order ID is",
    "orderExplanationText": "Next, the order will go through your organization's approval and finance processes, and if everything is in order, it will be shipped to the delivery address.",
    "orderExplanationTextForOrganization": "Next, the order will go through your organization's finance process, and if everything is in order, it will be shipped to the delivery address.",
    "deliveryEstimate1": "if your organizations approval and finance processes are completed before",
    "deliveryEstimate2": "Service description",
    "nextButton": "Back to user page",
    "nextButtonForOrganization": "Back to orders page"
  }
}
